import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';
import { LocaleId } from '../../models/locale/locale-id.enum';

export function localeIdFactory(
  countryIsoNumber: CountryIsoNumber,
  localeId?: LocaleId,
): LocaleId {
  if (localeId) {
    return localeId;
  }

  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return LocaleId.English_Ireland;
    case CountryIsoNumber.GreatBritain:
    default:
      return LocaleId.English_GreatBritain;
  }
}
